module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.d7d7b83.ttf";